import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext, useShowController } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import PhoneIcon from '@mui/icons-material/Phone'
import HailIcon from '@mui/icons-material/Hail'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TextField,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { blue, turquoise } from 'src/assets/colors'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { TransferCancellation } from './TransferCancellation'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import EditIcon from '@mui/icons-material/Edit'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { TransferForm } from 'src/components/pages/sales/reservation/logic/transfer/TransferForm'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { EditOriginValues } from '../common/EditOriginValues'
import { guaranteeItemReservation } from '../../helper/guaranteeItemReservation'
import { Comment, RemoveRedEye } from '@mui/icons-material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { itemServices } from 'src/services/reservation/item/item.service'
import { ComplementaryItemModal } from 'src/components/pages/sales/reservation/logic/modals/ComplementaryItemModal'
import { CreateItemSupplierModal } from 'src/components/pages/sales/reservation/logic/modals/CreateItemSupplierModal'
import { customAwait } from '../../helper/customAwait'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { useReservationInfo } from '../../context/ReservationContext'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { ExchangeType } from '../common/ExchangeType'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { retriveItemReservation } from '../../helper/retriveItemReservation'
import { CommentsCardComponent } from '../common/CommentsCardComponent'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'
import { ItemCancellation } from '../common/AutoCancelFields'
import { ChangePaymentStatusDialog } from '../common/ChangePaymentStatusDialog'
import { ChangeBillingStatusDialog } from '../common/ChangeBillingStatusDialog'
import { LoadingButton } from '@mui/lab'
import { TransferCodeEditModal } from '../modals/TransferCodeEditModal'

const DetailPickUp = ({ dropoff = false }) => {
  const transfer = useRecordContext()
  const translate = useTranslate()
  if (transfer) {
    let text = `[ ${transfer.pickup_type} ]${transfer.pickup_name}, ${transfer.pickup_code}`
    if (dropoff) {
      text = `[ ${transfer.dropoff_type} ]${transfer.dropoff_name}, ${transfer.dropoff_code}`
    }
    return <ShowElement data={text} label={translate('ra.field.pickup_type')} />
  }
}

const DropOffDetail = ({dropoff = false}) =>{
  const translate = useTranslate()
  const transfer = useRecordContext()

  const extra_type = dropoff ? "extra_return" : "extra"

  return(
      <>
        {transfer?.[extra_type]?.arrivalHotelName?.value && <ShowElement
          source={`${extra_type}.arrivalHotelName.value`}
          label={translate('ra.field.dropoff_type')}
        />}
        {transfer?.[extra_type]?.arrivalHotelAddress?.value && <ShowElement
          source={`${extra_type}.arrivalHotelAddress.value`}
          label={transfer?.[extra_type]?.arrivalHotelAddress.labelTranslated}
        />}
        {transfer?.[extra_type]?.arrivalBoatName?.value &&<ShowElement
          source={`${extra_type}.arrivalBoatName.value`}
          label={translate('ra.field.dropoff_type')}
        />}
        {transfer?.[extra_type]?.arrivalFlightNumber?.value &&<ShowElement
          source={`${extra_type}.arrivalFlightNumber.value`}
          label={translate('ra.field.dropoff_type')}
        />}
        {transfer?.[extra_type]?.arrivalTrainNumber?.value &&<ShowElement
          source={`${extra_type}.arrivalTrainNumber.value`}
          label={translate('ra.field.dropoff_type')}
        />}
      </>
    )
}

const PickUpDetail = ({dropoff = false}) =>{
  const translate = useTranslate()
  const transfer = useRecordContext()

  const extra_type = dropoff ? "extra_return" : "extra"

  return(
    <>
      {transfer?.[extra_type]?.departureHotelName?.value && <ShowElement
        source={`${extra_type}.departureHotelName.value`}
        label={translate('ra.field.pickup_type')}
      />}
      {transfer?.[extra_type]?.departureHotelAddress?.value && <ShowElement
        source={`${extra_type}.departureHotelAddress.value`}
        label={transfer?.[extra_type]?.departureHotelAddress?.labelTranslated}
      />}
      {transfer?.[extra_type]?.departureFlightNumber?.value &&<ShowElement
        source={`${extra_type}.departureFlightNumber.value`}
        label={translate('ra.field.pickup_type')}
      />}
      {transfer?.[extra_type]?.departureBoatName?.value &&<ShowElement
        source={`${extra_type}.departureBoatName.value`}
        label={translate('ra.field.pickup_type')}
      />}
      {transfer?.[extra_type]?.departureTrainNumber?.value &&<ShowElement
          source={`${extra_type}.departureTrainNumber.value`}
          label={translate('ra.field.pickup_type')}
        />}
    </>
  )
}

const ReserveInformation = ({reservation, refresh, isBillable, setIsBillable}) =>{
    const translate = useTranslate()
    const notify = useNotify()
    const [changeStatusDialog, setChangeStatusDialog] = useState(false)
    const transfer = useRecordContext()
    const [loadingBillable, setLoadingBillable] = useState(false)
    const [openCodeModal, setOpenCodeModal] = useState(false)
    const [changePaymentStatusDialog, setChangePaymentStatusDialog] = useState(false)
    const [changeBillingStatusDialog, setChangeBillingStatusDialog] = useState(false)

    const {
        isFetching
      } = useShowController()

    const onChangeBillable = async () =>{
      setLoadingBillable(true)
      const newValue = isBillable != undefined ? !isBillable: !transfer?.is_billable
      setIsBillable(newValue)
      await reservationServices.updateIsBillableProduct(transfer.hash_, newValue).then(()=>{
        notify('ra.notification.updated_success_masculine', {
            type: 'success',
            messageArgs: { element: translate('ra.single_entity.product') },
          })
      }).catch(()=>{
        notify('ra.notification.updated_error_masculine', {
          type: 'error',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
      }).finally(()=>{
        setLoadingBillable(false)
      })
    }
    return(
      <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
        <CompleteSideCard>
          <Box display={'flex'}>
            <LeftSideCard>
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                <ShowElement source='status' label={translate('ra.field.status')} />
                <HasPermission resource={'item'} permission='edit_status'>
                  <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                </HasPermission>
              </div>
              <ShowElement
                source='created_at'
                label={translate('ra.field.created_at')}
                dateFormatCustom={timeZoneFormat}
              />
              <ShowElement
                source='source_relation.short_name'
                label={translate('ra.field.source')}
              />
            </LeftSideCard>
            <RigthSideCard>
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                <ShowElement
                  source={'payment_status'}
                  label={translate('ra.field.payment_status')}
                  status
                />
                <HasPermission resource={'item'} permission='edit_payment_status'>
                  <EditIcon onClick={()=>setChangePaymentStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                </HasPermission>
              </div>
              <PassengerTransfer reservation={reservation} />
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                <BillingStatusField />
                <HasPermission resource={'billing'} permission='edit_status'>
                  <EditIcon onClick={()=>setChangeBillingStatusDialog(true)} style={{cursor:'pointer', fontSize:'17px', color:'#6f7ce0', marginLeft:'12px'}}/>
                </HasPermission>
              </div>

              {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                <Box style={{padding: '5px 0px 5px 0px'}}>
                  <Typography
                      variant='h7'
                      component='span'
                      style={{
                        padding: '0px 5px 0px 5px',
                        fontWeight: 600,
                        flex: 1,
                        maxWidth: 'fit-content',
                        display: 'inline-flex', 
                        alignItems: 'center',    
                        gap: '6px' 
                      }}
                    >
                    {translate('ra.field.is_billable')}
                    <Checkbox
                        checked={isBillable != undefined?isBillable:transfer?.is_billable}
                        onChange={onChangeBillable}
                        disabled={loadingBillable || isFetching}
                      />
                      {isFetching && (
                        <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />
                      )}
                  </Typography>
                </Box>
              )}
              <BillingAutomaticField />
            </RigthSideCard>
          </Box>
          <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
            {translate('ra.title.provider_info')}
          </Typography>
          <Box display={'flex'}>
            <LeftSideCard>
              <ShowElement
                source='supplier_relation.name'
                label={translate('ra.field.provider')}
              />
              <ShowElement
                source='pricing_relation.[0].currency_origin'
                label={translate('ra.field.currency')}
              />
            </LeftSideCard>
            <RigthSideCard>
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', whiteSpace:'nowrap'}}>
                <ShowElement source='code' label={translate('ra.field.provider_code')} />
                <EditIcon 
                  color={hasPermissionFunction('transfer-detail', 'edit_codes')?'primary':'disabled'}
                  onClick={()=>hasPermissionFunction('transfer-detail', 'edit_codes') && setOpenCodeModal(true)} 
                  style={{fontSize:'18px', cursor:hasPermissionFunction('transfer-detail', 'edit_codes') ? 'pointer':'default'}}
                />
              </div>
            </RigthSideCard>
          </Box>
        </CompleteSideCard>
        <ChangeStatusDialog
            open={changeStatusDialog}
            setOpen={setChangeStatusDialog}
            refresh={refresh}
          />
        <ChangePaymentStatusDialog
          open={changePaymentStatusDialog}
          setOpen={setChangePaymentStatusDialog}
          refresh={refresh}
        />
        <ChangeBillingStatusDialog
          open={changeBillingStatusDialog}
          setOpen={setChangeBillingStatusDialog}
          refresh={refresh}
        />

        <Dialog
          open={openCodeModal}
          onClose={()=>setOpenCodeModal(false)}
        >
          <DialogTitle>
            {translate('ra.title.code_edit')}
          </DialogTitle>
          <DialogContent>
            <TransferCodeEditModal refresh={refresh} setOpenCodeModal={setOpenCodeModal} />
          </DialogContent>
        </Dialog>
      </ShowCard>
    )
  }

const ExtraFields = () =>{
  const transfer = useRecordContext()
  const translate = useTranslate()
  if(transfer.extra){
    return(
      <>
        {/* {transfer.extra['kid-age'] && <ShowElement source='extra.kid-age.value' label={translate(`ra.field.${transfer.extra['kid-age']?.label}`)} />}
        {transfer.extra['kid-weight'] && <ShowElement source='extra.kid-weight.value' label={translate(`ra.field.${transfer.extra['kid-weight']?.label}`)} />} */}
        {transfer.extra['luggage'] && 
          <ShowElement boolean data={
            transfer.extra.luggage?.value === 'true' || transfer.extra.luggage?.value === true ? true : false
          } label={translate(
              `ra.field.${transfer.extra.luggage?.label?.split(' ')?.join('_')}`,
              { _: transfer.extra.luggage?.labelTranslated || transfer.extra.luggage?.label }
            )} 
        />}
      </>
    )
  }
  
}

const DropoffInfo = () => {
  const transfer = useRecordContext()
  const translate = useTranslate()

  return (
    (transfer.dropoff_origin && transfer.date_out) && (
      <Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
          {translate('ra.title.return')}
        </Typography>
        <Box display={'flex'}>
          <LeftSideCard>
            <ShowElement 
              source='dropoff_origin' 
              label={translate('ra.field.pickup_origin')} 
            />
            <ShowElement
              source='dropoff_origin_datetime'
              label={translate('ra.field.pickup_date')}
              dateTime
            />
            {/* <DetailPickUp dropoff /> */}
            <PickUpDetail dropoff={true}/>
            <ShowElement source='dropoff_destination' label={translate('ra.field.pickup_destination')} />
            <DropOffDetail dropoff={true} />
            <ExtraFields/>
          </LeftSideCard>
          <RigthSideCard>
            <ShowElement source='dropoff_transfer_type' label={translate('ra.field.pickup_transfer_type')} />
            <ShowElement source='dropoff_category' label={translate('ra.field.pickup_category')} />
            <ShowElement source='dropoff_vehicle' label={translate('ra.field.pickup_vehicle')} />
            <ShowElement source='total_pax' label={translate('ra.field.num_pax')} />
            <DestinationType/>
          </RigthSideCard>
        </Box>
      </Box>
    )
  )
}

const PassengerTransfer = ({ reservation }) => {
  const transfer = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = transfer?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextTransfer = ({ reservation }) => {
  const transfer = useRecordContext()
  if (transfer) {
    return (
      <>
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        {/* <TransferCancellation
          autoCancelDate={transfer?.autocancel_date}
          cancellations={transfer?.cancel_info_relation}
        /> */}
        <ItemCancellation
          autoCancelDate={transfer?.autocancel_date}
          cancellations={transfer?.cancel_info_relation}
        />
        <Passenger
          itemId={transfer.item_id}
          passengers={transfer?.pax_relation}
          idResource={reservation?.id}
        />
      </>
    )
  }
}

const ContextTransferForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const transfer = useRecordContext()
  if (transfer && openProductModal) {
    return (
      <TransferForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={transfer}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={transfer}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const LiquidationCards = ({enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)
  
  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  const handleCLickRule = (ruleId) => {
    if (ruleId) {
      window.open(`/#/business-rule/${ruleId}`, '_blank')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
             iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied}
                  </Button>
                  {item?.auth_code && (
                    <Tooltip title={`${translate('ra.field.rule_price_short')} ${item?.auth_code}`}>
                      <RemoveRedEye color='primary' />
                    </Tooltip>
                  )}
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_wholesaler' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
               iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              posTitle={
                <HasPermission resource={'business-rule'} permission='view'>
                  <Box sx={{ flex: 1, textAlign: 'end' }}>
                    <Button
                      variant='text'
                      onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied)}
                    >
                      {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied}
                    </Button>
                  </Box>
                </HasPermission>
              }
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing node_liquidation='liquidation_retail' />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_supplier' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const DestinationType = () =>{
  const translate = useTranslate()
  const transfer = useRecordContext()
  return(
    (transfer?.destination_type && 
      (transfer?.destination_type === 1 || 
      transfer?.destination_type === 2 ||
      transfer?.destination_type === 3)) &&
      <ShowElement
        data={
          transfer?.destination_type === 1 ? 
          translate('ra.destination_type.international') :
          transfer?.destination_type === 2 ? 
          translate('ra.destination_type.national') :
          transfer?.destination_type === 3 ? 
          translate('ra.destination_type.all') :
          'No'
        }
        styleValue={{ fontWeight: 600, color: turquoise }}
        label={translate('ra.field.destination_type')}
      />
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const transfer = useRecordContext()
  if (transfer) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={transfer} />
      </ShowCard>
    )
  }
}

export const TransferProduct = ({ reservation, transfer, editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()

  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')

  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)

  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)

  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)

  // const [exchangeMode, setExchangeMode] = useState(false)
  const { setOpenDueDateModal } = useReservationInfo()
  const [openProductModal, setOpenProductModal] = useState(false)
  const { setCardLoading } = useCardLoading()
  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [isBillable, setIsBillable] = useState()

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  const [openAfterSalesItemModal, setOpenAfterSalesItemModal] = useState(false)
  const [confirmAfterSalesItem, setConfirmAfterSalesItem] = useState(false)
  const [loadingAfterSalesReservationItem, setLoadingAfterSalesReservationItem] = useState(false)

  const [openComplementaryModal, setOpenComplementaryModal] = useState(false)
  const [loadingComplementaryItem, setLoadingComplementaryItem] = useState(false)
  const [openCreateItemSupplierModal, setOpenCreateItemSupplierModal] = useState(false)
  const [itemSupplierItemId, setItemSupplierItemId] = useState(null)

  const [openRetriveModal, setOpenRetriveModal] = useState(false)
  const [loadingRetriveItem, setLoadingRetriveItem] = useState(false)
  const [confirmRetrive, setConfirmRetrive] = useState(false)

  useEffect(() => {
      if (confirmRetrive) {
        retriveItemReservation({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setHashItemReserve,
          setLoadingRetriveItem,
          setNameReserve,
          setConfirmRetrive,
          setOpenRetriveModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmRetrive])

  useEffect(()=>{
    const items = reservation.items
    const foundItem = items.find(item=>item.id === transfer[0].id)
    setIsBillable(foundItem?.is_billable)
  },[reservation])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
    if (confirmRegisterReturn) {
      registerReturn({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingRegisterReturnItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmRegisterReturn,
        setOpenRegisterReturnModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRegisterReturn])

  useEffect(() => {
      if (confirmAfterSales) {
        afterSalesItemReservation({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingAfterSalesItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmAfterSales,
          setOpenAfterSalesModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmAfterSales])

  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
        onGuaranteeSuccess: () => {
          setOpenDueDateModal(true)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
        setOpenMoveModal(false)
      }
    }
  }

  if (transfer) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingCancelItem || loadingDeleteItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>
        <TabProduct
          products={transfer}
          labelGetter={(product) => (product?.id_detail ? product?.pickup_origin : 'ERROR')}
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='transfer-detail'
              loadingCancel={loadingCancelItem}
              onCancel={(transfer) => {
                setOpen(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)
              }}
              reservation={reservation}
              onDeleted={(transfer) => {
                setOpenDeleteModal(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(transfer) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onClone={(transfer) => {
                setOpenCloneModal(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)
              }}
              loadingCloneItem={loadingCloneItem}
              onMove={(transfer) => {
                setOpenMoveModal(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)
              }}
              onRefreshTransfer={(transfer)=>{
                setOpenRetriveModal(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)
              }}
              loadingMoveItem={loadingMoveItem}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(transfer)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(transfer?.hash_)
                setNameReserve(transfer?.pickup_origin)}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (transfer)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(transfer?.hash_)
                  setNameReserve(transfer?.pickup_origin)}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(transfer)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(transfer?.hash_)
                setActualStatus(transfer.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
              onAfterSalesItem={(transfer) => {
                setOpenAfterSalesItemModal(true)
                setHashItemReserve(transfer?.hash_)
              }
              }
              onComplementary={(transfer) => {
                setOpenComplementaryModal(true)
                setHashItemReserve(transfer?.hash_)
              }}
              loadingComplementaryItem={loadingComplementaryItem}
              onItemSupplierCreate={(transfer) => {
                setItemSupplierItemId(transfer?.item_id ?? transfer?.id)
                setOpenCreateItemSupplierModal(true)
              }}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextTransferForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ReserveInformation
                      reservation={reservation} 
                      refresh = {refresh} 
                      isBillable = {isBillable} 
                      setIsBillable = {setIsBillable}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                      <DialogContent>
                          <HistoryCostsDialog/>
                      </DialogContent>
                    </Dialog>
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.refresh_retrive_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRetriveModal}
                      setConfirm={setConfirmRetrive}
                      open={openRetriveModal}
                      loadingModalButton={loadingRetriveItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenGuaranteeModal}
                      setConfirm={setConfirmGuarantee}
                      open={openGuaranteeModal}
                      loadingModalButton={loadingGuaranteeItem}
                    />

                    <ConfirmationDialog
                        title={translate('ra.message.new_after_sales_item_confirmation')}
                        buttonConfirmText={translate('ra.message.yes')}
                        buttonCancel={translate('ra.message.no')}
                        setOpen={setOpenAfterSalesItemModal}
                        setConfirm={setConfirmAfterSalesItem}
                        open={openAfterSalesItemModal}
                        loadingModalButton={loadingAfterSalesReservationItem}
                      />
                    <ComplementaryItemModal
                      open={openComplementaryModal}
                      hashItem={hashItemReserve}
                      onClose={() => setOpenComplementaryModal(false)}
                    />

                    <CreateItemSupplierModal
                      open={openCreateItemSupplierModal}
                      itemId={itemSupplierItemId}
                      onClose={() => setOpenCreateItemSupplierModal(false)}
                    />

                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <LoadingButton loading={loadingMoveItem} variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </LoadingButton>
                      </DialogActions>
                    </Dialog>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard
                      iconHeader={<HailIcon />}
                      title={translate('ra.title.transfer_information')}
                      contentStyle={{ display: 'block' }}
                    >
                      <CompleteSideCard>
                        <Box>
                          <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
                            {translate('ra.title.going')}
                          </Typography>
                          <Box display={'flex'}>
                            <LeftSideCard>
                              <ShowElement
                                source='pickup_origin'
                                label={translate('ra.field.pickup_origin')}
                              />
                              <ShowElement
                                source='pickup_origin_datetime'
                                label={translate('ra.field.pickup_date')}
                                dateTime
                              />
                              {/* <DetailPickUp /> */}
                              <PickUpDetail/>
                              <ShowElement
                                source='pickup_destination'
                                label={translate('ra.field.pickup_destination')}
                              />
                              <DropOffDetail/>
                              <ExtraFields/>
                            </LeftSideCard>
                            <RigthSideCard>
                              <ShowElement
                                source='pickup_transfer_type'
                                label={translate('ra.field.pickup_transfer_type')}
                              />
                              <ShowElement
                                source='pickup_category'
                                label={translate('ra.field.pickup_category')}
                              />
                              <ShowElement
                                source='pickup_vehicle'
                                label={translate('ra.field.pickup_vehicle')}
                              />
                              <ShowElement source='total_pax' label={translate('ra.field.num_pax')} />
                              <DestinationType/>
                            </RigthSideCard>
                          </Box>
                        </Box>
                        <DropoffInfo />
                      </CompleteSideCard>
                      <CompleteSideCard>
                        <ContextTransfer reservation={reservation} />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <CommentsCardComponent />
                    </Grid>
                  </Grid>
              </WrapperCardId>
            </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  {/* <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.pricing')}
                    actionButtonIcon={<EditIcon />}
                    variant='text'
                    optionHeigth={'pricing'}
                    onClickButton={() => {
                      setOpenPricingModal(true)
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableBody>
                          {' '}
                          <Pricing />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ShowCard> */}
                </WrapperCardId>
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    reservation={reservation}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='revision' resource={'pricing'}>
                            <Button
                            onClick={()=>{setHistoryCostsDialog(true)}}
                            sx={{ paddingX: '10px', marginX:'5px' }}
                            size='small'
                            variant='contained'
                            >
                            {translate('ra.title.price_history')}
                            </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal}/>
                    </div>
                  )}
                  <LiquidationCards enableReliquidation={enableReliquidation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
